/* eslint-disable camelcase */
import { http } from '@/services/http'

export default {
  getList(searchParams) {
    return http.get('/templates', {
      params: searchParams
    })
  },
  getTemplateById(templateId) {
    return http.get(`/templates/${templateId}`)
  },
  getAssignedCountries(templateId) {
    return http.get(`/templates/countries/${templateId}`)
  },
  createTemplate(data) {
    return http.post('/templates', data)
  },
  updateTemplate(data) {
    return http.put(`/templates/${data.id}`, data)
  },
  deleteTemplate({ id }) {
    return http.delete(`/templates/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/templates.js